var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.title)?[_c('h4',{staticClass:"timeline-stop__title"},[_vm._v(" "+_vm._s(_setup.address)+" ")])]:[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"timeline-stop__title"},[_vm._v(" "+_vm._s(_setup.address)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }